import { Field, TextProps } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';
import { FieldError } from 'react-hook-form';

type Props = {
  label?: string;
  labelPosition?: TextProps['textAlign'];
  className?: string;
  children: ReactNode;
  error?: FieldError | undefined;
};

export type FieldWrapperPassThroughProps = Omit<Props, 'className' | 'children'>;

export const FieldWrapper = (props: Props): ReactElement => {
  const { label, labelPosition, className, error, children } = props;

  return (
    <Field.Root invalid={!!error?.message}>
      {label && (
        <Field.Label
          htmlFor={label}
          className={className}
          textStyle="body.m.regular"
          color="text.tertiary"
          textAlign={labelPosition}
        >
          {label}
        </Field.Label>
      )}
      {children}
      {error?.message && (
        <Field.ErrorText textStyle="body.xs.regular" color="text.error">
          {error.message}
        </Field.ErrorText>
      )}
    </Field.Root>
  );
};
